export const SMARTDATA_PROCESSING_OPTIONS = {
    PROCESS_BY_SMARTDATA: 'process-by-smartdata',
    UPLOAD_PREPROCESSED_DATA: 'upload-preprocessed-data'
};


export const DETECTION_OPTIONS = {
    "RUST": "rust",
    "POLE": "pole",
    "LANTANA": "lantana",
    "TOWER": "tower"
};

export const PRODUCTION_ENVIRONMENT = 'Production';
